import React from "react";
import { useProductCardContext } from "web/react/components/product-card/react";
import ProductCardLink from "web/react/components/product-card/react/product-card-link";
import { ProductCardImageEmo } from "web/react/emo/product-image";
import analytics from "web/script/analytics/analytics";

interface ProductCardImageProps {
    shouldRenderLeadLinkInImage?: boolean;
    action?: string;
    feedType?: string;
    analyticsEventLabel?: string;
}

export function ProductCardImage({
    feedType,
    action = "image",
    analyticsEventLabel,
    shouldRenderLeadLinkInImage,
}: ProductCardImageProps): JSX.Element {
    const {
        use_lazy_images: useLazyImages,
        image_url: imageURL,
        image_alt_text: imageAltText,
        id: productId,
    } = useProductCardContext();

    function handleClick(): void {
        analytics.event("product_card", action, analyticsEventLabel, false, {
            product_id: productId,
        });
    }

    return (
        <ProductCardLink
            reason="image"
            feedType={feedType}
            onClick={handleClick}
            predicate={shouldRenderLeadLinkInImage}
        >
            <ProductCardImageEmo src={imageURL} alt={imageAltText} lazy={useLazyImages} />
        </ProductCardLink>
    );
}
